import { createReducer } from '@reduxjs/toolkit'
import { types } from '../../actions/manual_pages/users_view_actions'
import MenuFilter, { updateItemsByPath } from './search'

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state: any, action: any) => {
      const { data, filter, page } = action

      if (filter) {
        return new MenuFilter(filter).getNewFilteredState(state, data.treeData)
      }

      if (page) {
        updateItemsByPath(data.treeData, page.path.concat(page.id), { subMenuState: 'expanded' })
      }

      state.treeData = data.treeData
      state.page = page
    })
    .addCase(types.UPDATE, (state: any, action: any) => {
      const { path, data } = action
      state.treeData = updateItemsByPath(state.treeData, path, data)
    })
    .addCase(types.UPDATE_NODE_AND_ALL_PARENTS, (state: any, action: any) => {
      const { path, data } = action
      state.treeData = updateItemsByPath(state.treeData, path, data)
    })
    .addCase(types.SEARCH, (state: any, action: any) => {
      return new MenuFilter(action.value).getNewFilteredState(state)
    })
    .addCase(types.BATCH_ACTION_TOGGLE_ID, (state: any, action: any) => {
      const { id } = action
      if (!state.checklists) {
        state.checklists = { selectedIds: [], ids: [] }
      }
      const index = state.checklists.selectedIds.indexOf(id)
      if (index === -1) {
        state.checklists.selectedIds.push(id)
      } else {
        state.checklists.selectedIds.splice(index, 1)
      }
    })
    .addCase(types.BATCH_ACTION_TOGGLE_ALL, (state: any) => {
      if (!state.checklists) {
        state.checklists = { selectedIds: [], ids: [] }
      }
      if (state.checklists.selectedIds.length === state.checklists.ids.length) {
        state.checklists.selectedIds = []
      } else {
        state.checklists.selectedIds = [...state.checklists.ids]
      }
    })
    .addCase(types.BATCH_ACTION_LOAD_IDS, (state: any, action: any) => {
      const { ids } = action
      if (!state.checklists) {
        state.checklists = { selectedIds: [], ids: [] }
      }
      state.checklists.ids = ids
    })
})
